<template>
  <div class="locations locations--grid container container--page-content flex flex-col gap-12 lg:gap-20">
    <div class="locations__header flex flex-col gap-5 lg:gap-6">
      <h2 class="locations__title lg:text-center">{{ component.locationsTitle }}</h2>
      <p class="locations__description text-regular-normal lg:text-center">{{ component.locationsDescription }}</p>
    </div>

    <div class="locations__content grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16">
      <div class="locations__item h-max" v-for="(location, index) in component.locations" :key="index">
        <SharedPicture
          :media="location.picture"
          height="260"
          width="480"
          format="webp"
          :quality="85"
          class="locations__item-image mb-13 rounded-sm mb-8 h-[260px] w-full lg:h-[418px] object-cover object-center !block md:!hidden"
          imageClass="rounded-sm overflow-hidden"
        />
        <SharedPicture
          :media="location.picture"
          height="480"
          width="625"
          format="webp"
          :quality="85"
          class="locations__item-image mb-13 rounded-sm mb-8 h-[260px] w-full lg:h-[418px] object-cover object-center !hidden md:!block"
          imageClass="rounded-sm overflow-hidden"
        />
        <h3 class="h4 locations__item-title text-center mb-4">{{ location.title }}</h3>
        <address class="locations__item-description text-regular-normal text-center mb-4 not-italic">{{ location.address }}</address>
        <a
          @click="trackGoogleMapsClick(location.title)"
          :href="location.googleMapsLink"
          class="locations__item-link flex items-center justify-center mt-6 gap-2 hover:text-accent hover:underline"
          target="_blank"
          rel="noopener noreferrer"
          :aria-label="t('components.locations.viewOnGoogleMaps')"
          :title="t('components.locations.viewOnGoogleMaps')"
        >
          <span class="locations__item-link-icon text-regular-link">
            {{ t('components.locations.viewOnGoogleMaps') }}
          </span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="locations__item-link-icon-svg text-white">
            <path d="M11.293 17.293L12.707 18.707L19.414 12L12.707 5.29297L11.293 6.70697L15.586 11H6V13H15.586L11.293 17.293Z" fill="currentColor" />
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { GraphQLLocations } from '~/types/graphql';

  interface EventData {
    event: 'locations_google_maps_click';
    location_title: string;
    page_location: string;
  }

  const { t } = useI18n();

  defineProps<{
    component: GraphQLLocations;
    index: number;
  }>();

  const { push } = useDataLayer();

  const trackGoogleMapsClick = (title: string) => {
    const eventData: EventData = {
      event: 'locations_google_maps_click',
      location_title: title,
      page_location: window.location.href,
    };
    push(eventData);
  };
</script>
